export default __webpack_public_path__ + "static/media/milestone 4200.1a3e353d.svg";